import { useMemo } from 'react'

import { Controller /* useFormContext */ } from 'react-hook-form'

import { IStatusProps } from './interface'
import { Multi } from '@/components/select/multi'

const Status = ({ control, accountKey, constants }: IStatusProps) => {
  const mappedData = useMemo(() => {
    return Object.values(constants).map(
      (item: { label: string }, key: number) => {
        return {
          value: key.toString(),
          ...item
        }
      }
    )
  }, [constants])

  return (
    <Controller
      key={accountKey}
      name='status'
      control={control}
      render={({ field: { onChange, value } }) => (
        <Multi
          value={value}
          onChange={onChange}
          label='Status da logística'
          loadOptions={() =>
            Promise.resolve({
              options: mappedData,
              hasMore: false,
              additional: { page: 1 }
            })
          }
        />
      )}
    />
  )
}

export default Status
